module.exports = __webpack_public_path__ + "img/4-1.c905e349.jpeg";